module.exports = __webpack_public_path__ + "static/La_Defense-722d0abe542a3574ca105fa8fea7e925.png";